<template>
  <v-select
      v-model="model"
      :items="data"
      :label="label"
      :loading="loading"
      clearable
      deletable-chips
      item-value="id"
      item-text="name"
      color="primary"
      placeholder="Select level"
  />
</template>

<script>
export default {
  name: "choose-level",
  props: ['label', 'value'],
  data() {
    return {
      isEditing: false,
      loading: false,
      model: this.value,
      search: null,
      data: [],
      cached: []
    }
  },
  mounted() {
    this.loading = true;
    const params = new URLSearchParams();
    params.append('perPage', "50");
    this.axios.get(`contract_template/level`, {params})
        .then((res) => {
          res.data.data.data.forEach(e => e.name += ' ' + e.contract_template.name);
          this.data = res.data.data.data;
        }).catch(err => console.log(err.message))
        .finally(() => this.loading = false);
  },
  watch: {
    model(val) {
      if (val)
        this.$emit("input", Number.parseInt(val));
      else {
        this.$emit('input', Number.parseInt(val));
      }
    }
  }
}
</script>

<style scoped>

</style>
